import { useIsDesktop } from "@swivl-mono/ui";
import React, { useState } from "react";

import { CustomerPickerActionSheet } from "./CustomerPickerActionSheet";
import { CustomerPickerModal, SelectedCustomer } from "./CustomerPickerModal";

interface CustomerPickerFieldProps {
  children: (props: { onClick: () => void }) => React.ReactNode;
  selectedCustomer: SelectedCustomer | null;
  onSelect: (customer: SelectedCustomer) => void;
  onRemove: () => void;
}

export function CustomerPickerField({ children, selectedCustomer, onSelect, onRemove }: CustomerPickerFieldProps): React.ReactElement {
  const [open, setOpen] = useState(false);
  const isDesktop = useIsDesktop();

  return (
    <>
      {children({ onClick: () => setOpen(true) })}
      {isDesktop ? (
        <CustomerPickerModal open={open} onClose={() => setOpen(false)} onSelect={onSelect} selectedCustomer={selectedCustomer} onRemove={onRemove} />
      ) : (
        <CustomerPickerActionSheet
          open={open}
          onClose={() => setOpen(false)}
          onSelect={onSelect}
          selectedCustomer={selectedCustomer}
          onRemove={onRemove}
        />
      )}
    </>
  );
}
